@if (isAdmin()) {
	<div>
		<app-course-title>Admin Quick Enroll</app-course-title>

		@if (loading()) {
			<div class="spin-container">
				<nz-spin nzSimple nzSize="large"></nz-spin>
			</div>
		} @else {
			<div class="sections">
				@if (sections().length > 0) {
					@for (section of sections(); track section.uuid; let i = $index) {
						<button
							(click)="enrollInSection(section)"
							[disabled]="sectionsUuidsAlreadyEnrolled().includes(section.uuid)"
						>
							{{ section.name }}
						</button>
					}
				} @else {
					<h1>No sections found in client.</h1>
				}
			</div>
		}
	</div>
}
